









































import Vue from "vue";

export default Vue.extend({
  name: "Profile",
  data: () => ({}),
  computed: {
    profile() {
      return this.$store.state.profile.userData;
    },
  },
});
